"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFINITION_PRIORITY = void 0;
exports.mergeBoundaries = mergeBoundaries;
exports.mergeResources = mergeResources;
exports.mergeFunctions = mergeFunctions;
exports.DEFINITION_PRIORITY = 1;
function mergeBoundaries(definitionBoundaries, inferenceReportBoundaries) {
    const inferenceReportBoundaryValues = inferenceReportBoundaries?.map((entry) => entry.boundary) ?? [];
    const topLevelBoundaries = definitionBoundaries ?? [];
    return [...inferenceReportBoundaryValues, ...topLevelBoundaries];
}
function mergeResources(definitionResources, inferenceReportResources) {
    const allResourcesWithPriority = [
        ...(definitionResources ?? []).map((r) => ({ priority: exports.DEFINITION_PRIORITY, resource: r })),
        ...(inferenceReportResources ?? []).map((r) => ({
            priority: r.priority ?? 0,
            resource: r.resource,
        })),
    ].sort((a, b) => a.priority - b.priority);
    const resourceMap = new Map();
    for (const { resource } of allResourcesWithPriority) {
        const key = resource.name;
        resourceMap.set(key, resource);
    }
    return Array.from(resourceMap.values());
}
function mergeFunctions(definitionFunctions, inferenceReportFunctions) {
    const allFunctionsWithPriority = [
        ...(definitionFunctions ?? []).map((f) => ({ priority: exports.DEFINITION_PRIORITY, function: f })),
        ...(inferenceReportFunctions ?? []).map((f) => ({
            priority: f.priority ?? 0,
            function: f.function,
        })),
    ].sort((a, b) => a.priority - b.priority);
    const functionMap = new Map();
    for (const { function: func } of allFunctionsWithPriority) {
        functionMap.set(func.name, func);
    }
    return Array.from(functionMap.values());
}
//# sourceMappingURL=ComponentMergeUtils.js.map